import {
	pricingRegionByID,
	pricingRegionCreate,
	pricingRegionDestroy,
	pricingRegionUpdate,
	pricingRegionsList,
} from '@/services/pricingRegions.service'

export default {
	namespaced: true,
	state: {
		regionsList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		region: {},
		regionsStatus: 'pending',
		regionsSaveStatus: 'init',
		regionsDeleteStatus: 'init',
	},
	getters: {
		getRegionsList(state) {
			return state.regionsList
		},
		getRegion(state) {
			return state.region
		},
		getRegionsStatus(state) {
			return state.regionsStatus
		},
		getRegionsSaveStatus(state) {
			return state.regionsSaveStatus
		},
		getRegionsDeleteStatus(state) {
			return state.regionsDeleteStatus
		},
	},
	mutations: {
		REGIONS_LIST(state, value) {
			state.regionsList = value
		},
		SET_REGION(state, value) {
			state.region = value
		},
		REGIONS_STATUS(state, value) {
			state.regionsStatus = value
		},
		REGION_SAVE_STATUS(state, value) {
			state.regionsSaveStatus = value
		},
		REGION_DELETE_STATUS(state, value) {
			state.regionsDeleteStatus = value
		},
	},
	actions: {
		async fetchRegionList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('REGIONS_STATUS', 'pending')
			commit('REGIONS_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await pricingRegionsList(params)
				commit('REGIONS_STATUS', 'init')
				commit('REGIONS_LIST', data)

				return data
			} catch (error) {
				commit('REGIONS_STATUS', 'init')
				throw error
			}
		},
		async fetchRegionByID({ commit }, params) {
			commit('REGIONS_STATUS', 'pending')
			try {
				const { data } = await pricingRegionByID(params)
				commit('REGIONS_STATUS', 'init')
				commit('SET_REGION', data.data)

				return data
			} catch (error) {
				commit('REGIONS_STATUS', 'init')
				throw error
			}
		},
		async saveNewRegion({ commit }, params) {
			commit('REGION_SAVE_STATUS', 'pending')
			try {
				const { data } = await pricingRegionCreate(params)
				commit('REGION_SAVE_STATUS', 'init')

				return data
			} catch (error) {
				commit('REGION_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateRegion({ commit }, params) {
			commit('REGION_SAVE_STATUS', 'pending')
			try {
				const { data } = await pricingRegionUpdate(params)
				commit('REGION_SAVE_STATUS', 'init')

				return data
			} catch (error) {
				commit('REGION_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteRegionByID({ commit }, params) {
			commit('REGION_DELETE_STATUS', 'pending')
			try {
				const { data } = await pricingRegionDestroy(params)
				commit('REGION_DELETE_STATUS', 'init')

				return data
			} catch (error) {
				commit('REGION_DELETE_STATUS', 'error')
				throw error
			}
		},
	},
}
